import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { useSelector } from 'react-redux'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'

import AppLoader from '../../components/Loaders/AppLoader'

import { getAppDomainName } from '../../features/helpers/getAppDomainName'

import { adAccountsLoadingSelector } from '../../modules/selectors/adAccounts'

import useStyles from './../styles'

function UnauthorizedPage({ helmetTitle, children, className }) {
  const classes = useStyles({})

  const { t } = useTranslation()
  const appName = getAppDomainName()

  const isLoading = useSelector(adAccountsLoadingSelector)

  return (
    <>
      <Helmet>
        <title>
          {t(helmetTitle)} · {appName}
        </title>
      </Helmet>
      {isLoading && <AppLoader showTopMenu />}
      <main className={classes.main}>
        <div className={classnames(classes.container, className)}>{children}</div>
      </main>
    </>
  )
}

export default UnauthorizedPage

UnauthorizedPage.propTypes = {
  helmetTitle: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node
}
